import { Mail, MapPin, MessageCircle, Phone, Clock } from "lucide-react";
import { useSettings } from "@/components/site/Footer";

export default function Contact() {
  const s = useSettings();
  const rows = [
    [MapPin, "Address", s.address], [Phone, "Phone", s.phone], [Mail, "Email", s.email],
    [MessageCircle, "WhatsApp", s.whatsapp], [Clock, "Business hours", s.business_hours],
  ];
  return (
    <div className="container-x py-16">
      <p className="text-xs font-bold uppercase tracking-widest text-amber-600">Contact us</p>
      <h1 className="mt-2 text-4xl font-extrabold tracking-tight sm:text-5xl">We're here to help</h1>
      <p className="mt-3 max-w-2xl text-slate-600">For recruitment queries, quote your application reference. For product orders, quote your order number. Recruitment fees and product payments are handled separately.</p>
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="contact-details">
        {rows.map(([Icon, label, val]) => (
          <div key={label} className="rounded-2xl border border-slate-200 bg-white p-6">
            <Icon className="mb-3 h-5 w-5 text-amber-600" />
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500">{label}</p>
            <p className="mt-1 font-semibold">{val || "—"}</p>
          </div>
        ))}
        {s.grievance_officer && (
          <div className="rounded-2xl border border-slate-200 bg-white p-6"><p className="text-xs font-bold uppercase tracking-widest text-slate-500">Grievance officer</p><p className="mt-1 font-semibold">{s.grievance_officer}</p></div>
        )}
      </div>
    </div>
  );
}
